import cx from "classnames";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import { XboxSpinner } from "../XboxSpinner";
import * as styles from "./LoadingPage.module.css";

export const LoadingPage = () => (
  <Container>
    <Row className={cx(styles.loadingContainerRow, "justify-content-center", "align-items-center")}>
      <Col className="col-auto">
        <XboxSpinner />
      </Col>
    </Row>
  </Container>
);
